module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "custom-new-pats-patients",
    attrs: {
      "id": "forms"
    }
  }, [_c('div', {
    staticClass: "custom-new-pats-patients__container"
  }, [_c('div', {
    staticClass: "custom-new-pats-patients__title",
    domProps: {
      "innerHTML": _vm._s(_vm.props.title)
    }
  }), _c('div', {
    staticClass: "custom-new-pats-patients__row"
  }, [_c('div', {
    staticClass: "custom-new-pats-patients__left"
  }, [_c('div', {
    staticClass: "custom-new-pats-patients__text",
    domProps: {
      "innerHTML": _vm._s(_vm.props.text)
    }
  })]), _c('div', {
    staticClass: "custom-new-pats-patients__right",
    style: ({
      backgroundImage: 'url(' + _vm.props.img + ')'
    })
  })])])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-5df88493","hasScoped":false}!./~/vue-loader/lib/template-compiler/preprocessor.js?engine=pug!./src/components/custom/custom-new-pats-patients/custom-new-pats-patients.pug
// module id = 708
// module chunks = 1